import BaseViewController from "../base-view-controller";

class AddressEditViewController extends BaseViewController {
  handleButtonClick(
    name,
    text,
    action,
    replaceHistory,
    initialScreen,
    eventStates
  ) {
    if (name === "same_as_home") {
      const { copyAddressTitle, clearAddressTitle } = action.data;
      const { addressLine1, addressLine2, city, countryCode, state, zipcode } =
        action.data.datastore.hashifiedStorage.profileInformation
          .mailingAddress;

      const field = this.screen.fields.find(f => f.name === name);
      const addressEmpty = field.title === copyAddressTitle;

      const changeButtonText = () =>
        addressEmpty
          ? (field.title = clearAddressTitle)
          : (field.title = copyAddressTitle);

      const populateFormWithMailingAddress = () =>
        this.appData.handleChange({
          mailing_address: addressLine1,
          mailing_address_line_2: addressLine2,
          mailing_city: city,
          mailing_region: countryCode,
          mailing_province_state: state,
          postal_mailing: zipcode
        });

      const clearForm = () =>
        this.appData.handleChange({
          mailing_address: "",
          mailing_address_line_2: "",
          mailing_city: "",
          mailing_region: "",
          mailing_province_state: "",
          postal_mailing: ""
        });

      if (addressEmpty) {
        populateFormWithMailingAddress();
      } else {
        clearForm();
      }
      changeButtonText();
    } else {
      super.handleButtonClick(
        name,
        text,
        action,
        replaceHistory,
        initialScreen,
        eventStates
      );
    }
  }
}

export default AddressEditViewController;
